module.exports = __webpack_public_path__ + "img/07.08efedf5.png";